<template>
    <Head>
        <title>Авансовый баланс</title>
    </Head>

    <authenticated-layout>

        <template #header>
            <organization-navigation :organization-id="organizationId"/>
        </template>

        <div class="flex flex-col gap-6">

            <div class="flex flex-col bg-white" v-if="success">
                <div v-if="rows.length" class="grid grid-cols-6 p-2 gap-2 items-end text-sm font-bold">
                    <span class="col-span-2">ID авансового</span>
                    <span>Баланс</span>
                    <span>бонусный</span>
                    <span>Валюта</span>
                    <span>Доступны для депозита</span>
                </div>

                <div v-for="row in rows" class="grid grid-cols-6 border-t p-2 gap-2 items-center text-sm">
                    <span class="col-span-2">{{ row.accountId }}</span>
                    <span>{{ row.balance }}</span>
                    <span>{{ row.bonusBalance }}</span>
                    <span>{{ row.currency }}</span>
                    <span>{{ row.availableDeposit.join(', ') }}</span>
                </div>
            </div>

            <div class="flex flex-col gap-2 bg-white"  v-if="access('organizations', 'advanced_analytics')">
                <form class="grid grid-cols-6 px-6 pt-2 gap-2 items-end"
                      @submit.prevent="updateAnalytics">
                    <h2 class="col-span-3 text-xl pb-4 font-bold">Аналитика</h2>
                    <v-input label="Дата начала" type="date" v-model="analytics.date.from"/>
                    <v-input label="Дата окончания" type="date" v-model="analytics.date.to"/>
                    <v-button color="green">Обновить</v-button>
                </form>
                <div class="grid grid-cols-5 gap-6 px-6 items-end text-sm font-bold">
                    <span class="text-right">Баланс</span>
                    <span class="text-right">Комиссия блокчейна</span>
                    <span class="text-right">Пользователя</span>
                    <span class="col-span-2 text-center">Комиссия по тарифам</span>
                </div>
                <div v-if="analytics.success">
                    <div v-for="(r, id) of analytics.result"  class="grid grid-cols-5 gap-6 py-2 px-6 border-t">
                        <div class="flex flex-col text-right">
                            <span class="text-xs text-gray-500">В начале периода</span>
                            <span class="font-mono">{{ r.startBalance }}</span>
                            <span class="text-xs text-gray-500">В конце периода</span>
                            <span class="font-mono">{{ r.endBalance }}</span>
                        </div>
                        <span class="text-right font-mono">{{ r.blockchainFees }}</span>
                        <div class="flex flex-col text-right">
                            <span class="text-xs text-gray-500">Приход</span>
                            <span class="font-mono">{{ r.incr }}</span>
                            <span class="text-xs text-gray-500">Расход</span>
                            <span class="font-mono">{{ r.decr }}</span>
                            <span class="text-xs text-gray-500">Возврат</span>
                            <span class="font-mono">{{ r.refund }}</span>
                        </div>
                        <div class="col-span-2">
                            <div v-show="r.tariffShow || false" v-for="(rt, i) of r.tariffFees">
                                <div class="grid grid-cols-4 text-xs" :class="(i % 2) ? '' : 'bg-gray-100'">
                                    <div class="col-span-2">{{ rt.type }}</div>
                                    <div>
                                        <span v-if="rt.currencyId && currencies[rt.currencyId]">{{ currencies[rt.currencyId].name ||  '' }}</span>
                                        <span v-if="rt.networkId && networks[rt.networkId]">({{ networks[rt.networkId].name ||  '' }})</span>
                                    </div>
                                    <div class="text-right font-mono">{{ rt.amount }}</div>
                                </div>
                            </div>
                            <div class="grid grid-cols-3">
                                <span class="col-span-2 text-blue-700 cursor-pointer" @click="r.tariffShow = !r.tariffShow">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-6 w-6 mx-auto" viewBox="0 0 16 16">
                                        <path v-if="r.tariffShow || false" fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                                        <path v-else fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                                    </svg>
                                </span>
                                <span class="text-right font-mono">
                                    {{ r.tariffFees.reduce((a, b) => a.plus(b.amount), new BigNumber(0)) }}
                                </span>
                            </div>
                        </div>
                        <div class="col-span-full text-xs text-gray-400">
                            # <span>{{ id }}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>


    </authenticated-layout>

</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import OrganizationNavigation from "@/Components/Navigation/Organization";
import VInput from "@/Components/Input.vue";
import VButton from "@/Components/Button.vue";
const BigNumber = require("bignumber.js");

export default {
    computed: {
        BigNumber() {
            return BigNumber
        }
    },
    components: {
        VButton, VInput,
        OrganizationNavigation,
        Head, Link,
        AuthenticatedLayout,
    },
    props: {
        notifications: Array,
        organizationId: String,
        success: Boolean,
        rows: Object,
    },
    data() {
        return {
            analytics: {
                success: false,
                date: {from: null, to: null},
                result: null,
            },
            currencies: {},
            networks: {},
        }
    },
    methods: {
        updateAnalytics() {
            if(!this.access('organizations', 'advanced_analytics'))
                return;
            axios.get(this.route('organization.advanced.analytics', this.organizationId), {params: this.analytics.date})
                .then(res => {
                    const {success, result, date, currencies, networks, notifications} = res.data;
                    this.notifications.push(...notifications);
                    this.analytics.success = success;
                    this.analytics.date = date;
                    this.analytics.result = result;
                    this.currencies = currencies;
                    this.networks  = networks;
                });
        }
    },
    mounted() {
        this.updateAnalytics();
    },
}
</script>
